import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';
import CountDownComponent from '../countDownClock';

const ErrorLoggedInRFID = ({ text, closePopup }) => {
  const t = useTranslation();

  return (
    <div className="popup-content popup-small">
      <i
        onClick={closePopup}
        className="global-icon icon-Close close-popup"
      />
      <CountDownComponent second={200} />
      <div className="popup-message error" />
      <div className="popup-title">
        {t(text)}
      </div>
    </div>
  );
};

ErrorLoggedInRFID.propTypes = {
  text: PropTypes.string,
  closePopup: PropTypes.func.isRequired,
};

export default ErrorLoggedInRFID;
